import { render, staticRenderFns } from "./SubDivisions.vue?vue&type=template&id=16f701a4&scoped=true&"
import script from "./SubDivisions.vue?vue&type=script&lang=js&"
export * from "./SubDivisions.vue?vue&type=script&lang=js&"
import style0 from "./SubDivisions.vue?vue&type=style&index=0&id=16f701a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f701a4",
  null
  
)

export default component.exports